import React, { useEffect,useCallback, useRef,useMemo, useState } from 'react';
// import AgGrid from "./AgGrid"
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { columnwithDefs } from "./columnDefs_vehicles";
import Constants from "./Masters_constants";
import redirectURL from "../redirectURL";
import EditItem from './EditItem'
import DeletePartner from './deleteItem'
import SweetAlert from 'react-bootstrap-sweetalert';
import { getHyphenDDMMMYYYYHHMM } from '../common/utils';
import { format } from 'date-fns';
import BulkUploadModal from './BulkUploadModal.js';
import Select from 'react-select';
import {SubmitBtn} from "../common/utils.js";




function Masters() {
    var [rowData, setRowData] = useState([])
    var [columnDefs1, setColumnDefs1] = useState([
        // {
        //     headerName: "Action",
        //     field: "_id",
        //     resizable: true,
        //     width: 90,
        //     filter: false,
        //     cellRenderer: EditItem,
        //     pinned: "left",
        //         headerClass: 'bold-header'
        //     // editable: false
        // },
        {
            headerName: "",
            field: "_id",
            width: 50,
            cellRenderer: DeletePartner,
            pinned: "left",
                headerClass: 'bold-header'
        },
        {
                headerName: "",
                field: "submit_btn",
                colId: "submit_btn",
                width: 80,
                filter:false, 
                resizable: true,
                cellRendererSelector: function (param) {
                    try {
                        // Check if any edit was made (i.e., if isEdited is true)
                       
                            return {
                                component: SubmitBtn,
                                params: {
                                    onClickEditDeliveryDate: onClickSaveODA,
                                }
                            };
                      
                    } catch (err) {
                        console.log(err);
                    }
                },
            }
       
        // {
        //     headerName: "Created Date",
        //     field: "created_date",
        //     width: 220,
        //     type: "datetime",
        //     filter: true,
        //     valueGetter: (params) => {
        //         if (!params.value) return '';
        //         const date = new Date(params.value);
        //         return format(date, 'dd-MM-yyyy');
        //     },
        // }
    
    ])
    const [showBulkUploadModal, setShowBulkUploadModal] = useState(false);
    var odaMasterColumns =[
       
          
    
          {
            headerName: "Destination Pincode",
            field: "consignee_pincode",
            width: 240,
            filter: true,
            editable: true,
            resizable: true,
            valueGetter: function (params) {
              // Ensure a valid pincode is returned (only 6 digits allowed)
              const pincode = params.data.consignee_pincode;
              return pincode && /^[0-9]{6}$/.test(pincode) ? pincode : "";
            },
            valueSetter: function (params) {
              const newValue = params.newValue.trim();
              // Validate if the pincode is exactly 6 digits
              if (/^[0-9]{6}$/.test(newValue)) {
                params.data.consignee_pincode = newValue; // Store valid pincode
                return true; // Accept the change
              } else {
                params.data.consignee_pincode = ""; // Clear invalid pincode
                return false; // Reject the change
              }
            },
            cellStyle: function (params) {
              // Highlight the cell with a red background if consignee_pincode is invalid
              const pincode = params.value;
              if (!/^[0-9]{6}$/.test(pincode)) {
                return {
                  backgroundColor: "#c85f62", // Light red background for invalid pincode
                };
              }
              return null; // No special styling for valid pincode
            },
            headerClass: 'bold-header'
          }
          ,
        
    
       
        {
            headerName: "DP WORLD",
            field: "DP WORLD",
            width: 140,
            filter: true,
            editable: true,
            resizable:true,
            cellEditor: 'agSelectCellEditor',
            cellEditorParams: {
                values: ['Yes', 'No'],  // Values to appear in the dropdown
            },

        },
        {
            headerName: "CCF LOGISTICS",
            field: "CCF LOGISTICS",
            width: 140,
            filter: true,
            editable: true,
            resizable:true,
            cellEditor: 'agSelectCellEditor',
            cellEditorParams: {
                values: ['Yes', 'No'],  // Values to appear in the dropdown
            },

        },
        {
            headerName: "GATI KWE",
            field: "GATI KWE",
            width: 140,
            filter: true,
            editable: true,
            resizable:true,
            cellEditor: 'agSelectCellEditor',
            cellEditorParams: {
                values: ['Yes', 'No'],  // Values to appear in the dropdown
            },

        },
        {
            headerName: "MODERN CLEARING AGENCY",
            field: "MODERN CLEARING AGENCY",
            width: 140,
            filter: true,
            editable: true,
            resizable:true,
            cellEditor: 'agSelectCellEditor',
            cellEditorParams: {
                values: ['Yes', 'No'],  // Values to appear in the dropdown
            },

        },
        {
            headerName: "NEW SURAJ",
            field: "NEW SURAJ",
            width: 140,
            filter: true,
            editable: true,
            resizable:true,
            cellEditor: 'agSelectCellEditor',
            cellEditorParams: {
                values: ['Yes', 'No'],  // Values to appear in the dropdown
            },

        },
        {
            headerName: "SWASTIKA LOGISTICS",
            field: "SWASTIKA LOGISTICS",
            width: 140,
            filter: true,
            editable: true,
            resizable:true,
            cellEditor: 'agSelectCellEditor',
            cellEditorParams: {
                values: ['Yes', 'No'],  // Values to appear in the dropdown
            },

        },
        {
            headerName: "TRANSMILO",
            field: "TRANSMILO",
            width: 140,
            filter: true,
            editable: true,
            resizable:true,
            cellEditor: 'agSelectCellEditor',
            cellEditorParams: {
                values: ['Yes', 'No'],  // Values to appear in the dropdown
            },

        },
        {
            headerName: "UNIVELOX",
            field: "UNIVELOX",
            width: 140,
            filter: true,
            editable: true,
            resizable:true,
            cellEditor: 'agSelectCellEditor',
            cellEditorParams: {
                values: ['Yes', 'No'],  // Values to appear in the dropdown
            },

        },
        {
            headerName: "VASANT LOGISTICS",
            field: "VASANT LOGISTICS",
            width: 140,
            filter: true,
            editable: true,
            resizable:true,
            cellEditor: 'agSelectCellEditor',
            cellEditorParams: {
                values: ['Yes', 'No'],  // Values to appear in the dropdown
            },

        },
        {
            headerName: "KERRYINDEVEXPRESS",
            field: "KERRYINDEVEXPRESS",
            width: 140,
            filter: true,
            editable: true,
            resizable:true,
            cellEditor: 'agSelectCellEditor',
            cellEditorParams: {
                values: ['Yes', 'No'],  // Values to appear in the dropdown
            },

        },
        {
            headerName: "DNX CARGO",
            field: "DNX CARGO",
            width: 140,
            filter: true,
            editable: true,
            resizable:true,
            cellEditor: 'agSelectCellEditor',
            cellEditorParams: {
                values: ['Yes', 'No'],  // Values to appear in the dropdown
            },

        },
        {
            headerName: "NAVATA ROAD TRANSPORT",
            field: "NAVATA ROAD TRANSPORT",
            width: 140,
            filter: true,
            editable: true,
            resizable:true,
            cellEditor: 'agSelectCellEditor',
            cellEditorParams: {
                values: ['Yes', 'No'],  // Values to appear in the dropdown
            },

        },
        {
            headerName: "MOVIN EXPRESS",
            field: "MOVIN EXPRESS",
            width: 140,
            filter: true,
            editable: true,
            resizable:true,
            cellEditor: 'agSelectCellEditor',
            cellEditorParams: {
                values: ['Yes', 'No'],  // Values to appear in the dropdown
            },

        },
        {
            headerName: "V XPRESS",
            field: "V XPRESS",
            width: 140,
            filter: true,
            editable: true,
            resizable:true,
            cellEditor: 'agSelectCellEditor',
            cellEditorParams: {
                values: ['Yes', 'No'],  // Values to appear in the dropdown
            },

        },
        {
            headerName: "ABHILASH LOGISTICS",
            field: "ABHILASH LOGISTICS",
            width: 140,
            filter: true,
            editable: true,
            resizable:true,
            cellEditor: 'agSelectCellEditor',
            cellEditorParams: {
                values: ['Yes', 'No'],  // Values to appear in the dropdown
            },

        },
        {
            headerName: "SRI RANGA TRANSPORT",
            field: "SRI RANGA TRANSPORT",
            width: 140,
            filter: true,
            editable: true,
            resizable:true,
            cellEditor: 'agSelectCellEditor',
            cellEditorParams: {
                values: ['Yes', 'No'],  // Values to appear in the dropdown
            },

        },
        {
            headerName: "BHARAT FREIGHT",
            field: "BHARAT FREIGHT",
            width: 140,
            filter: true,
            editable: true,
            resizable:true,
            cellEditor: 'agSelectCellEditor',
            cellEditorParams: {
                values: ['Yes', 'No'],  // Values to appear in the dropdown
            },

        },
        {
            headerName: "BATCOTRANS LOGISTICS",
            field: "BATCOTRANS LOGISTICS",
            width: 140,
            filter: true,
            editable: true,
            resizable:true,
            cellEditor: 'agSelectCellEditor',
            cellEditorParams: {
                values: ['Yes', 'No'],  // Values to appear in the dropdown
            },

        },

        {
            headerName: "PATIL TRANSPORT",
            field: "PATIL TRANSPORT",
            width: 140,
            filter: true,
            editable: true,
            resizable:true,
            cellEditor: 'agSelectCellEditor',
            cellEditorParams: {
                values: ['Yes', 'No'],  // Values to appear in the dropdown
            },

        },
        
          
        
    ]
    var tatMasterColumns1 =[
        {
            headerName: "Destination Pincode",
            field: "consignee_pincode",
            width: 200,
            filter: true,
            resizable: true,
            editable: true,
            tooltipField: "consignee_pincode",  // Show pincode in tooltip
            tooltipComponentParams: {
                tooltip: "Pincode must be a 6-digit number"
            },
            valueSetter: (params) => {
                const pincode = params.newValue;
                const regex = /^\d{6}$/;  // Regex for a 6-digit number
        
                if (regex.test(pincode)) {
                    params.data[params.colDef.field] = pincode;
                    return true;
                } else {
                    alert("Please enter a valid 6-digit pincode.");
                    params.data[params.colDef.field] = ''; // Clear invalid value
                    return false;
                }
            }
        },
        
    
        {
            headerName: "DP WORLD",
            field: "DP WORLD",
            width: 140,
            filter: true,
            editable: true,
            resizable:true,
            cellEditor: 'agSelectCellEditor',
            cellEditorParams: {
                values: ['','YES', 'NO'],  // Values to appear in the dropdown
            },
        },
        {
            headerName: "CCF LOGISTICS",
            field: "CCF LOGISTICS",
            width: 140,
            filter: true,
            editable: true,
            resizable:true,
            cellEditor: 'agSelectCellEditor',
            cellEditorParams: {
                values: ['','YES', 'NO'],  // Values to appear in the dropdown
            },

        },
        {
            headerName: "GATI KWE",
            field: "GATI KWE",
            width: 140,
            filter: true,
            editable: true,
            resizable:true,
            cellEditor: 'agSelectCellEditor',
            cellEditorParams: {
                values: ['','YES', 'NO'],  // Values to appear in the dropdown
            },
        },
        {
            headerName: "MODERN CLEARING AGENCY",
            field: "MODERN CLEARING AGENCY",
            width: 140,
            filter: true,
            editable: true,
            resizable:true,
            cellEditor: 'agSelectCellEditor',
            cellEditorParams: {
                values: ['','YES', 'NO'],  // Values to appear in the dropdown
            },
        },
        {
            headerName: "NEW SURAJ",
            field: "NEW SURAJ",
            width: 140,
            filter: true,
            editable: true,
            resizable:true,
            cellEditor: 'agSelectCellEditor',
            cellEditorParams: {
                values: ['','YES', 'NO'],  // Values to appear in the dropdown
            },
        },
        {
            headerName: "SWASTIKA LOGISTICS",
            field: "SWASTIKA LOGISTICS",
            width: 140,
            filter: true,
            editable: true,
            resizable:true,
            cellEditor: 'agSelectCellEditor',
            cellEditorParams: {
                values: ['','YES', 'NO'],  // Values to appear in the dropdown
            },
        },
        {
            headerName: "TRANSMILO",
            field: "TRANSMILO",
            width: 140,
            filter: true,
            editable: true,
            resizable:true,
            cellEditor: 'agSelectCellEditor',
            cellEditorParams: {
                values: ['','YES', 'NO'],  // Values to appear in the dropdown
            },
        },
        {
            headerName: "UNIVELOX",
            field: "UNIVELOX",
            width: 140,
            filter: true,
            editable: true,
            resizable:true,
            cellEditor: 'agSelectCellEditor',
            cellEditorParams: {
                values: ['','YES', 'NO'],  // Values to appear in the dropdown
            },
        },
        {
            headerName: "VASANT LOGISTICS",
            field: "VASANT LOGISTICS",
            width: 140,
            filter: true,
            editable: true,
            resizable:true,
            cellEditor: 'agSelectCellEditor',
            cellEditorParams: {
                values: ['','YES', 'NO'],  // Values to appear in the dropdown
            },
        },
        {
            headerName: "KERRYINDEVEXPRESS",
            field: "KERRYINDEVEXPRESS",
            width: 140,
            filter: true,
            editable: true,
            resizable:true,
            cellEditor: 'agSelectCellEditor',
            cellEditorParams: {
                values: ['','YES', 'NO'],  // Values to appear in the dropdown
            },
        },
        {
            headerName: "DNX CARGO",
            field: "DNX CARGO",
            width: 140,
            filter: true,
            editable: true,
            resizable:true,
            cellEditor: 'agSelectCellEditor',
            cellEditorParams: {
                values: ['','YES', 'NO'],  // Values to appear in the dropdown
            },
        },
        {
            headerName: "NAVATA ROAD TRANSPORT",
            field: "NAVATA ROAD TRANSPORT",
            width: 140,
            filter: true,
            editable: true,
            resizable:true,
            cellEditor: 'agSelectCellEditor',
            cellEditorParams: {
                values: ['','YES', 'NO'],  // Values to appear in the dropdown
            },
        },
        {
            headerName: "MOVIN EXPRESS",
            field: "MOVIN EXPRESS",
            width: 140,
            filter: true,
            editable: true,
            resizable:true,
            cellEditor: 'agSelectCellEditor',
            cellEditorParams: {
                values: ['','YES', 'NO'],  // Values to appear in the dropdown
            },
        },
        {
            headerName: "V XPRESS",
            field: "V XPRESS",
            width: 140,
            filter: true,
            editable: true,
            resizable:true,
            cellEditor: 'agSelectCellEditor',
            cellEditorParams: {
                values: ['','YES', 'NO'],  // Values to appear in the dropdown
            },
        },
        {
            headerName: "ABHILASH LOGISTICS",
            field: "ABHILASH LOGISTICS",
            width: 140,
            filter: true,
            editable: true,
            resizable:true,
            cellEditor: 'agSelectCellEditor',
            cellEditorParams: {
                values: ['','YES', 'NO'],  // Values to appear in the dropdown
            },
        },
        {
            headerName: "SRI RANGA TRANSPORT",
            field: "SRI RANGA TRANSPORT",
            width: 140,
            filter: true,
            editable: true,
            resizable:true,
            cellEditor: 'agSelectCellEditor',
            cellEditorParams: {
                values: ['','YES', 'NO'],  // Values to appear in the dropdown
            },
        },
        {
            headerName: "BHARAT FREIGHT",
            field: "BHARAT FREIGHT",
            width: 140,
            filter: true,
            editable: true,
            resizable:true,
            cellEditor: 'agSelectCellEditor',
            cellEditorParams: {
                values: ['','YES', 'NO'],  // Values to appear in the dropdown
            },
        },
        {
            headerName: "BATCOTRANS LOGISTICS",
            field: "BATCOTRANS LOGISTICS",
            width: 140,
            filter: true,
            editable: true,
            resizable:true,
            cellEditor: 'agSelectCellEditor',
            cellEditorParams: {
                values: ['','YES', 'NO'],  // Values to appear in the dropdown
            },
        },
        {
            headerName: "PATIL TRANSPORT",
            field: "PATIL TRANSPORT",
            width: 140,
            filter: true,
            editable: true,
            resizable:true,
            cellEditor: 'agSelectCellEditor',
            cellEditorParams: {
                values: ['','YES', 'NO'],  // Values to appear in the dropdown
            },
        },
        
    ]
    var [columnDefs, setColumnDefs] = useState([...columnDefs1, ...tatMasterColumns1])
    var [consignerPincode,setConsignerPincode]= useState("")
    var [consigneePincode,setConsigneePincode]= useState("")
    var [transporterName,setTransporterName]= useState({label:"", value:""})


    const onClickOpenBulkUploadModal = () => {
        setShowBulkUploadModal(true);
        setoverlay("show-m")
    };

    const closeBulkUploadModal = () => {
        setShowBulkUploadModal(false);
        setoverlay("show-n")

    };

    // var [showloaderbg, setshowloaderbg] = useState("show-m");
    const gridApiConsignments = useRef();
    const columnApiConsignments = useRef(null);
    var [showloader, setshowloader] = useState("show-m");
    var [showAddSlider, setshowAddSlider] = useState("");
    var [overlay, setoverlay] = useState("show-n");
    var [rowid ,setRowId] = useState();
    var [sliderText, setSliderText] = useState("");
    const [isEditMode, setIsEditMode] = useState(false);
    var [vehicle_capacity, setvehiclecapacity] = useState("");
    var [vehicle_type, setvehicletype] = useState("");
    var [is_active, setstatus] = useState("");
    var [courierPartnerList, setCourierPartnerList] = useState([])
    var [tptRecords, settptRecords] = useState([])
    // var modules = useState(AllModules);
    var paginationPageSize = useState(50);

    var [show, setShow] = useState(false);
    var [basicType, setBasicType] = useState("");
    var [basicTitle, setBasicTitle] = useState("");
    var [deleteConfirmationSlide, setDeleteConfirmationSlide] = useState("");
    var [deleteRowData, setDeleteRowData] = useState("");
    

    const defaultColDef = useMemo(() => {
        return {
            //flex: 1,
            resizable:true,
            sortable: true,
            filter: true,
            editable:false

        };
    }, []);

    var onGridReady = (params) => {
        // gridApi = params.api;
        // gridColumnApi = params.columnApi;
        console.log('params',params)
        console.log('Grid Ready. Column API:', params.columnApi);
        // gridApiRef.current = params.api; 
        // gridColumnApiRef.current = params.columnApi;
    }
    var [transporter_name, settransportername] = useState({label:"", value:""});
    var [consignee_pincode, setconsigneepincode] = useState("");
    var [consigner_pincode, setconsignerpincode] = useState("");
    var [transit_time, settransittime] = useState("");
    var [pincodeError, setPincodeError] = useState("");
    var [pincodeError1, setPincodeError1] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);
    const pageSize = 50; 
    

    const onGridReadyConsignments = useCallback((params) => {
        gridApiConsignments.current = params.api
        columnApiConsignments.current = params.columnApi
    }, []);

    const getCurrentFormattedDate = () => {
        const date = new Date();
        return format(date, 'dd-MM-yyyy');
    };

    const getCurrentISODate = () => {
        const date = new Date();
        return date.toISOString();
    };

    useEffect(() => {
        setTimeout(() => {
            // setshowloaderbg("show-n")
            setshowloader("show-n")
        }, 2000)
        if (currentPage === 1) {
            loadData(1);
        }        
        try{
            redirectURL.post('/consignments/getTransportersList')
        .then(resp => {
            var records = resp.data.tptMaster;
            // console.log(simTrackingtps, "simTrackingTpts99");
            
            var tptNames = records.map((e)=> e.transporter_name);
            var tptNamesLowercase= records.map((e)=> e.transporter_name.toLowerCase());
            settptRecords(tptNamesLowercase)

            var tptNamesList=[]
            for (let i of tptNames){
                tptNamesList.push({label:i, value: i})
            }
            // tptNamesList.push({label:"Others", value:"Others"});
            setCourierPartnerList(tptNamesList)
        }) 
        }catch (error) {
            console.error("Error fetching transporters list:", error);
          }
        

        // 
    }, [])

    var loadData = async (page) => {
        
        var parameters = { page, limit: pageSize };
        
        await redirectURL.post('/getODADetails', parameters)
            .then(response => {
                console.log(response, "oda response ui");
                
                if (response.data.status === "success") {
                    const updatedRecords = response.data.records.map(record => ({
                        ...record,
                        disabled: true
                    }));
                    setRowData(updatedRecords);
                    setTotalRecords(response.data.totalRecords); // Store total records for pagination
                    setCurrentPage(page);
                    if (gridApiConsignments.current) {
                        gridApiConsignments.current.paginationGoToPage(page - 1); // AG Grid pages start at 0
                    }
                }
                setshowloader("show-n");
            })
            .catch(error => console.error('Error fetching data:', error));
    };
    var loadPreviousData =()=>{
        if(currentPage===1){
            let totalPages= Math.ceil(totalRecords / pageSize)
            loadData(totalPages)
        }else{
            loadData(currentPage-1)
        }
    }
    var loadNextData =() =>{
        let totalPages= Math.ceil(totalRecords / pageSize)
        if(currentPage===totalPages){
            loadData(1)
        }else{
            loadData(currentPage+1)
        }
    }
    var loadDatalast =() =>{
        let totalPages= Math.ceil(totalRecords / pageSize)
      
            loadData(totalPages)
    }
    var onClickDeleteItem = async (rownode) => {
        // console.log("Rownode Update", rownode);
        setDeleteConfirmationSlide("slide95")
        setoverlay("show-m")
        setDeleteRowData(rownode)
    };

    var onsubmitdelete = async (rownode) => {
        // console.log("Rownode Update", rownode);
        var params = {
            row_id: deleteRowData.data._id
        }
    
        try {
            const resp = await redirectURL.post('/deleteODADetails', params);
            // console.log(resp,"resp",resp.data.status,"success");
            
            if (resp.data.status === "success") {
                setDeleteConfirmationSlide("")

                setoverlay("show-n");
                setshowloader("show-n");
                setShow(true);
                setBasicTitle("ODA Deleted Successfully");
                setBasicType("success");
                loadData(1);
            }
        } catch (error) {
            console.error("Error deleting vehicle details:", error);
        }
    };
    var hideDeleteSubmit = ()=>{
        setDeleteConfirmationSlide("");
        setoverlay("show-n");
    
    }

    var showAddBlock = async (rownode) => {
        setshowAddSlider("slider-translate-30p");
        setoverlay("show-m")
        setSliderText("Add ODA");
        setvehiclecapacity("");
        setvehicletype("");
        setIsEditMode(false);

    }

    var onClickEditBlock  = async (rownode) =>{
        // console.log("rownode ", rownode)
        setshowAddSlider("slider-translate-30p");
        setoverlay("show-m");
        setSliderText("Edit TAT");
        setRowId(rownode.data._id);
        setvehiclecapacity(rownode.data.vehicle_capacity);
        settransportername({label:rownode.data.transporter_name, value:rownode.data.transporter_name} );
        setconsigneepincode(rownode.data.consignee_pincode)
        setconsignerpincode(rownode.data.consigner_pincode)
        settransittime(rownode.data.transit_time)
        setvehicletype(rownode.data.vehicle_type);
        setIsEditMode(true);
    }
    var onClickSaveODA  = async (rownode) =>{
        console.log("rownode ", rownode)
        const modifiedDate = getCurrentISODate();

        let params={
            data: rownode.data,
            modifiedDate:modifiedDate
            
        }
        // setLoader(true)
        //console.log(bulkLRError,bulkUpdateInvoiceError,bulkUpdateDispatchError,bulkUpdateExpectedError,bulkUpdateLastEventTimeError, bulkUpdateStatusError,bulkUpdateCurrentLocationErr,bulkUpdateEventError, bulkUpdateReasonErr, "bulkUpdateEventError");
        await redirectURL.post('/saveODAMaster', params).then((resp) => {
            // console.log(resp, "edit response");
            if (resp.data.status == "success") {
                setoverlay("show-n");
                setshowAddSlider("");
                setshowloader("show-n");
                settransportername({label:"", value:""})
                setconsigneepincode("")
                setconsignerpincode("")
                settransittime("")
                setstatus("");
                setIsEditMode(false);
                setRowId("");
                setShow(true);
                setBasicTitle("Updated ODA Data");
                setBasicType("success");
                loadData(1);
            }
        });
        // if (gridApiConsignments.current) {
        //     gridApiConsignments.current.stopEditing();
        //     const gridRowData = [];
        //     gridApiConsignments.current.forEachNode((node) => {
        //             gridRowData.push(node.data)
        //     })
        //     if (gridRowData.length > 0) {
        //             await redirectURL.post("/bulkUploadLRConsignments", { consignments: gridRowData, email: decode(localStorageEmail) })
        //             .then(response => {
                        
        //                 if (response.data.status == "Success") {
        //                     setShow(true)
        //                     setTitle(response.data.message)
        //                     setType("success")
        //                     setLoader(false)
        //                     setModalBulkLRData([])
        //                     setOverlay("show-n")
        //                     setFile3(null); 
        //                     setshowBulkLRForm("")
        //                     setLoadShow("show-n")
        //                     setLoadshowBulkLr("show-n")
        //                     setOverlayBulkUpload("show-n")

        //                     // window.location.reload()

        //                 }
        //                 else {
        //                     setShow(true)
        //                     setTitle(response.data.message)
        //                     setType("danger")
        //                     setLoader(false)
        //                     setLoadShow("show-n")
        //                     setLoadshowBulkLr("show-n")
        //                     setOverlayBulkUpload("show-n")

        //                 }
        //             })
        //             .catch(err => console.log(err))
                
        //     }
        //         }
    }

    var hideAll = () => {
        setoverlay("show-n");
        setshowAddSlider("");
    }


    var saveMasterForm = async (e) => {
        e.preventDefault();
        let user_email = localStorage.getItem('email');
        // setshowloaderbg("show-m");
        const createdDate = getCurrentISODate();
        setshowloader("show-m")
        if(isEditMode) {
            var params = {
                rowid: rowid,
                transporter_name: transporter_name.value,
                consignee_pincode: consignee_pincode,
                consigner_pincode: consigner_pincode,
                transit_time: transit_time,

                // is_active: is_active,
                modified_date: createdDate,
            }
        }
        else {
            var params = {
                consignee_pincode: "",
                dp_world: "",
                ccf_logistics: "",
                gati_kwe:"",
                clearing:"",
                new_suraj:"",
                swastika_logistics:"",
                transmilo:"",
                univelox:"",
                vasant_logistics:"",
                kerryindevexpress:"",
                dnx_cargo:"",
                navata_road_transport:"",
                movin_express:"",
                v_xpress:"",
                abhilash_logistics:"",
                sri_ranga_transport:"",
                bharat_freight:"",
                batcotrans_logistics:"",
                patil_transport:"",
                // is_active: is_active,
                created_date: createdDate,
            }
        }
        
        // console.log(params, "params");
        // console.log(isEditMode, "edit mode");
        if (isEditMode) {
            await redirectURL.post('/updateODAMaster', params).then((resp) => {
                // console.log(resp, "edit response");
                if (resp.data.status == "success") {
                    setoverlay("show-n");
                    setshowAddSlider("");
                    setshowloader("show-n");
                    settransportername({label:"", value:""})
                    setconsigneepincode("")
                    setconsignerpincode("")
                    settransittime("")
                    setstatus("");
                    setIsEditMode(false);
                    setRowId("");
                    setShow(true);
                    setBasicTitle("Updated TAT Data");
                    setBasicType("success");
                    loadData(1);
                }
            });
        } else {
                
                await redirectURL.post('/addODA', params).then((resp) => {
                    if (resp.data.status == "success") {
                        setoverlay("show-n");
                        setshowAddSlider("");
                        setIsEditMode(false);
                        // setShow(true);
                        // setBasicTitle("Added TAT Data");
                        // setBasicType("success");
                        loadData(1);
                    } else if (resp.data.status === "failure") {
                        setoverlay("show-n");
                        setshowloader("show-n");
                        setIsEditMode(false);
                        setshowAddSlider("");
                        settransportername({label:"", value:""})
                        setconsigneepincode("")
                        setconsignerpincode("")
                        settransittime("")
                        setstatus("");
                        setShow(true);
                        setBasicTitle(resp.data.message);
                        setBasicType("danger");
                    }
                }).catch(err => {
                });
            
           
        }
    };


    var handleTransporterName = (e) => {
       settransportername(e)
    };
    var onClickSubmitFilter = async()=>{
        
        var params = {
            consigner_pincode: consignerPincode,
            consignee_pincode: consigneePincode,
            transporter_name: transporterName.value
        }
        if(transporterName.value!=="" && consigneePincode!=="" && consignerPincode !==""){
            await redirectURL.post('/tatMasterFilter', params).then((resp) => {
                // console.log(resp.data, "edit response");
                 const updatedRecords = resp.data.records.map(record => ({
                        ...record,
                        disabled: true
                    }));
                if (resp.data.status == "success") {
                    setRowData(updatedRecords)
                    
                   
                    // loadData(1);
                }
            });
        }else{
            setShow(true);
            setBasicTitle("Please select all mandatory fields");
            setBasicType("danger");
        }
    }
    var onClickResetFilter = async()=>{
        setTransporterName({label:"", value:""})
        setConsigneePincode("")
        setConsignerPincode("")
        
        loadData(1)
    }
    const handleConsigneePincode = (e) => {
        const value = e.target.value;
      
        // Only allow numbers and limit to 6 digits
        const regex = /^[0-9]{0,6}$/; // Regex for allowing up to 6 digits
      
        // Check if the value matches the regex and update the state accordingly
        if (regex.test(value)) {
          setconsigneepincode(value); // Update pincode value if valid
          setPincodeError(""); // Clear error if valid
        } else {
          setPincodeError("Please enter a valid 6-digit pincode"); // Show error if invalid
        }
      };
      const handleConsignerPincode = (e) => {
        const value = e.target.value;
      
        // Only allow numbers and limit to 6 digits
        const regex = /^[0-9]{0,6}$/; // Regex for allowing up to 6 digits
      
        // Check if the value matches the regex and update the state accordingly
        if (regex.test(value)) {
          setconsignerpincode(value); // Update pincode value if valid
          setPincodeError1(""); // Clear error if valid
        } else {
          setPincodeError1("Please enter a valid 6-digit pincode"); // Show error if invalid
        }
      };
      const handleTransitTime = (e) => {
        const value = e.target.value;
    
        // Validate if the input is numeric (only numbers)
        if (/^\d*\.?\d*$/.test(value)) {
          settransittime(value); // Update state with valid numeric value
        //   setTransitTimeError(""); // Clear the error message
        } else {
        //   setTransitTimeError("Please enter a valid numeric value"); // Show error for invalid input
        }
      };
        const handleEditable = (params) => {
        setRowData(prevUsers =>
    prevUsers.map(row =>
      row._id === params.data._id ? { ...row, disabled:false  } : row
    )
  );
    }
    return (
        <div>
            <div className="container-fluid">
                <SweetAlert
                    show={show}
                    type={basicType}
                    title={basicTitle}
                    onConfirm={() => {
                        setShow(false)
                    }}>
                </SweetAlert>


            </div>
            <div className="container-fluid">
    {/* Row for Header and Buttons */}
    <div className="row align-items-center justify-content-between mb-3">
        {/* Heading */}
        <div className="col-auto">
            <h5 className="f18 d-flex align-items-center master-title">
                <i className="icofont icofont-vehicle-delivery-van cus-i"></i>&nbsp;ODA Master
            </h5>
        </div>

        {/* Buttons */}
        <div className="col-auto d-flex">
            {/* <button
                title="Bulk Upload"
                onClick={onClickOpenBulkUploadModal}
                className="btn btn-warning mr-2"
                type="button"
                style={{ padding: "8px 15px", height: "35px" }}
            >
                <i className="fa fa-upload"></i>&nbsp;Upload ODA's
            </button> */}

            <BulkUploadModal
                show={showBulkUploadModal}
                onClose={closeBulkUploadModal}
                columnDefs={odaMasterColumns}
                screen={"oda_master"}
                templateUrl={require('../../assets/json/oda_master_template.csv')}
            />
            {Constants.VEHICLES.BTN_ADD === 1 && (
                <button
                    className="btn btn-warning"
                    onClick={saveMasterForm}
                    style={{ padding: "8px 15px", height: "35px" }}
                >
                    <i className="icon-plus"></i>&nbsp;Add ODA
                </button>
            )}
        </div>
    </div>

    {/* Main Content */}
    <div className="row">
        <div className="col-xl-12 col-md-12 xl-60">
            <div className="card">
                <div className="card-body">
                {/* <div class="row">
                            <div class={" col-xl-2 col-lg-2 form-group"}>
                                
                                <label style={{fontWeight:"700", fontSize:"13px"}}>Consigner Pincode<span style={{color: 'red'}}>*</span></label>
                                <input 
                                    type="text" 
                                    name="consigner_pincode" 
                                    id="consignerPincode"  
                                    placeholder={"Consigner Pincode"}
                                    autoComplete="off" 
                                    className="form-control" 
                                    value={consignerPincode}
                                    style={{fontSize:"13px", padding:"7px"}}
                                    onChange={(e)=> setConsignerPincode(e.target.value)} 
                                    maxLength={6}/>
                                    
                            </div>
                            <div class={" col-xl-2 col-lg-2 form-group"}>
                                <label style={{fontWeight:"700", fontSize:"13px"}}>Consignee Pincode<span style={{color: 'red'}}>*</span></label>
                                <input 
                                    type="text" 
                                    name="consignee_pincode" 
                                    id="consigneePincode"  
                                    placeholder={"Consignee Pincode"}
                                    autoComplete="off" 
                                    className="form-control" 
                                    value={consigneePincode}
                                    style={{fontSize:"13px", padding:"7px"}}
                                    onChange={(e)=> setConsigneePincode(e.target.value)}
                                    maxLength={6} />
                            </div>
                            <div class={" col-xl-3 col-lg-3 form-group"}>
                                <label style={{fontWeight:"700", fontSize:"13px"}}>Transporter Name<span style={{color: 'red'}}>*</span></label>
                                <Select
                                                    closeMenuOnSelect={true}
                                                    value={transporterName}
                                                    onChange={(e)=>
                                                        setTransporterName(e)
                                                    }
                                                    style={{ borderRadius: "0px" }}
                                                    styles={{
                                                        control: (provided, state) => ({
                                                        ...provided,
                                                        fontSize: "0.8rem",
                                                        color: "#6e707e",
                                                        width:"100%"
                                                        }),
                                                        singleValue: (provided, state) => ({
                                                        ...provided,
                                                        fontSize: "0.9rem",
                                                        }),
                                                    }}
                                                    options={courierPartnerList}
                                                    // isDisabled={true}

                                                />
                            </div>
                           
                            <div class="col-xl-2 col-lg-2 form-group" style={{paddingTop:"30px"}}>
                                    <label></label>
                                    <button type="submit" onClick={onClickSubmitFilter} class="btn btn-success">Get Data</button>
                                    &nbsp;
                                    <button type="submit" onClick={onClickResetFilter} class="btn btn-default">Reset</button>

                            </div>
                                
                           
                            
                        </div> */}
                    <div
                        className="ag-theme-balham mt-3"
                        style={{ height: "500px", width: "100%" }}
                    >
                        <AgGridReact
                            onCellEditingStarted={handleEditable}
                            columnDefs={columnDefs}
                            rowData={rowData}
                            defaultColDef={defaultColDef}
                            pagination={true}
                            paginationPageSize={pageSize}
                            paginationAutoPageSize={false}
                            suppressPaginationPanel={true}
                            // onPaginationChanged={(params) => {
                            //     if (params.api) {
                            //         const newPage = params.api.paginationGetCurrentPage() + 1; // Convert 0-based to 1-based
                            //         console.log("Changing to Page:", newPage);
                            //         loadData(newPage); // ✅ Load new page data
                            //     }
                            // }}
                            onGridReady={onGridReadyConsignments}                            
                            enableRangeSelection={true}
                            enableCellContextMenu={true}
                            masterDetail={true}
                            context={{ onClickEditBlock, onClickDeleteItem }}
                            sideBar={{
                                toolPanels: [
                                    {
                                        id: "columns",
                                        labelDefault: "Columns",
                                        labelKey: "columns",
                                        iconKey: "columns",
                                        toolPanel: "agColumnsToolPanel",
                                        toolPanelParams: {
                                            suppressPivotMode: true,
                                            suppressRowGroups: true,
                                            suppressValues: true,
                                        },
                                    },
                                    {
                                        id: "filters",
                                        labelDefault: "Filters",
                                        labelKey: "filters",
                                        iconKey: "filter",
                                        toolPanel: "agFiltersToolPanel",
                                    },
                                ],
                            }}
                            statusBar={{
                                statusPanels: [
                                    {
                                        statusPanel: "agTotalAndFilteredRowCountComponent",
                                        align: "left",
                                    },
                                    {
                                        statusPanel: "agTotalRowCountComponent",
                                        align: "center",
                                    },
                                    { statusPanel: "agFilteredRowCountComponent" },
                                    { statusPanel: "agSelectedRowCountComponent" },
                                    { statusPanel: "agAggregationComponent" },
                                ],
                            }}
                        />
                    </div>
                    <div className="pagination-controls">
                    <span 
        onClick={()=>{
            
            loadData(1)
        }} 
        style={{ cursor: "pointer", marginRight: "5px" }}
    >
        {"<"}
    </span>
    <button 
        // disabled={currentPage === 1} 
        // onClick={() => loadData(currentPage - 1)}
        onClick={loadPreviousData}
    >
        Previous
    </button>
    
    <span> 
        Page {currentPage} of {Math.ceil(totalRecords / pageSize)} 
        | Total Records:{totalRecords.toLocaleString("en-IN")}
    </span>    
    <button 
        // disabled={currentPage * pageSize >= totalRecords} 
        onClick={loadNextData}
    >
        Next
    </button>
    <span 
        onClick={()=>{
            
            loadDatalast()
        }} 
        style={{ cursor: "pointer", marginRight: "5px" }}
    >
        {">"}
    </span>
</div>
                </div>
            </div>
        </div>
       
    </div>
   

</div>


            <div className={"overlay-part " + (overlay)} onClick={hideAll}></div>

            <div className={"slide-r " + showAddSlider}>
                <div className="slide-r-title">
                <h4 className="slide-r-title">{sliderText}
                <span className="float-right closebtn" style={{ marginRight: "25px" }} onClick={hideAll} >X</span>

                    </h4>

                </div>
                <div className="slide-r-body">

                <form className="" style={{ padding: "20px" }} onSubmit={saveMasterForm}>
                {/* <div className="form-group">
                            <label style={{ display: "block", marginBottom: "5px" }}>Consigner Pincode<span style={{ color: 'red' }}>*</span></label>
                            <input type="text" name="consigner_pincode" value={consigner_pincode} style={{
                                width: "100%",
                                padding: "10px",
                                border: "1px solid #ccc",
                                borderRadius: "4px",
                                backgroundColor: "#f9f9f9",
                            }} 
                            autoComplete='off'
                            onChange={handleConsignerPincode} required 
                            disabled={isEditMode}/>
                        </div> */}
                        <div className="form-group">
                            <label style={{ display: "block", marginBottom: "5px" }}>Destination Pincode<span style={{ color: 'red' }}>*</span></label>
                            <input type="text" name="consignee_pincode" value={consignee_pincode} style={{
                                width: "100%",
                                padding: "10px",
                                border: "1px solid #ccc",
                                borderRadius: "4px",
                                backgroundColor: "#f9f9f9",
                            }} 
                            autoComplete='off'
                            onChange={handleConsigneePincode} required
                            disabled={isEditMode} />
                        </div>
                        {/* {pincodeError!==""&& 
                        <div style={{ color: "red", fontSize: "12px", paddingTop: "5px", paddingLeft: "20px" }}>
                        {pincodeError}
                    </div>} */}
                        
                        {/* {pincodeError1!==""&& 
                        <div style={{ color: "red", fontSize: "12px", paddingTop: "5px", paddingLeft: "20px" }}>
                        {pincodeError1}
                    </div>} */}

                        {/* <div className="form-group">
                            <label style={{ display: "block", marginBottom: "5px" }}>Transporter Name<span style={{ color: 'red' }}>*</span></label>
                            <Select
                            closeMenuOnSelect={true}
                             value={transporter_name}
                            // multi={true}
                            // className={"border-radius-0"} 
                            onChange={handleTransporterName}
                            options={courierPartnerList}
                            // style={{ borderRadius: "0px" }}
                            isDisabled={isEditMode}
                            >
                        </Select> 
                         
                        </div> */}

                        {/* <div className="form-group">
                            <label style={{ display: "block", marginBottom: "5px" }}>Transit Time<span style={{ color: 'red' }}>*</span></label>
                            <input type="text" name="transit_time" value={transit_time} style={{
                                width: "100%",
                                padding: "10px",
                                border: "1px solid #ccc",
                                borderRadius: "4px",
                                backgroundColor: "#f9f9f9",
                            }} 
                            autoComplete='off'
                            onChange={handleTransitTime} required />
                        </div> */}


                     

                        {isEditMode ? 
                        <>
                        <div className="form-group" style={{ textAlign: "center" }}>
                            <button type="submit" className="btn btn-success"
                                style={{
                                    padding: "10px 20px",
                                    border: "none",
                                    borderRadius: "4px",
                                    backgroundColor: "#28a745",
                                    color: "white",
                                }}
                            >Update TAT</button>
                        </div>
                        </>
                        :
                        <>
                        <div className="form-group" style={{ textAlign: "center" }}>
                            <button type="submit" className="btn btn-success"
                                style={{
                                    padding: "10px 20px",
                                    border: "none",
                                    borderRadius: "4px",
                                    backgroundColor: "#28a745",
                                    color: "white",
                                }}
                            >Add ODA</button>
                        </div>
                        </>
                        }
                        {/* <div className="form-group" style={{ textAlign: "center" }}>
                            <button type="submit" className="btn btn-success"
                                style={{
                                    padding: "10px 20px",
                                    border: "none",
                                    borderRadius: "4px",
                                    backgroundColor: "#28a745",
                                    color: "white",
                                }}
                            >Add Transporter</button>
                        </div> */}

                    </form>
                </div>

            </div>
            {deleteConfirmationSlide
                 && 
                 <div className={"sliderBlock3 " + (deleteConfirmationSlide)} >
                <span className="float-right ffclosebtn1" style={{ marginRight: "25px", fontSize: '20px' }} onClick={hideDeleteSubmit} >
                    <img src={require('../../assets/images/closeIcon.png')} className='closeIcon mt-5p' style={{ marginTop: "-40px" }} />
                </span>
                <div className='d-flex mt-60p' style={{marginLeft:"42px"}}>
                            <div className='d-flex flex-column ml-20p'>
                                <h1 className='confirm-heading'>Are you sure you want to delete ?</h1>
                            </div>
                </div>                
                <div className='d-flex flex-row ml-30p mt-20p'>
                    <button className='btn_confirm_cancel' style={{ marginRight: "36px", marginLeft: "15px" }} onClick={hideDeleteSubmit} >Cancel</button>
                    <button className='btn_hover8' onClick={onsubmitdelete}>Delete</button>
                </div>

                </div>}

            <div className={"dataLoadpage " +(showloader)}>
                </div>
                <div className={"dataLoadpageimg " +(showloader)}>
                    <div class="loader-box"><div class="loader-box"><div class="rotate dashed colored"></div></div></div>
                </div>
                <div className={"overlay-part "+(overlay)} ></div>


        </div>
    );
}

export default Masters;
